import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";
import { GraduationCap } from "lucide-react";

export default function BearsInCollege() {
  const { site } = useSite();
  const players = [...site.college].sort((a, b) => (b.grad_year ?? 0) - (a.grad_year ?? 0));

  return (
    <div data-testid="college-page">
      <PageHeader
        eyebrow="Bears Alumni"
        title="Bears in College"
        subtitle={site.content.subtitle_college}
        testid="college-header"
      />

      <section className="py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {players.length === 0 ? (
            <div className="bg-white rounded-lg border border-slate-200 p-12 sm:p-16 text-center max-w-xl mx-auto" data-testid="college-empty-state">
              <div className="h-16 w-16 rounded-full bg-[#0F4C2A]/10 flex items-center justify-center mx-auto mb-5">
                <GraduationCap size={30} className="text-[#0F4C2A]" />
              </div>
              <h2 className="font-condensed text-2xl font-bold uppercase text-slate-900">Coming Soon</h2>
              <p className="mt-3 text-slate-600 text-sm sm:text-base">No Bears in College players have been added yet.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="college-grid">
              {players.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 0.07}>
                  <div className="card-lift bg-white rounded-lg border border-slate-200 overflow-hidden h-full hover:border-[#0F4C2A]/40" data-testid={`college-card-${p.id}`}>
                    {p.photo && (
                      <img src={p.photo} alt={p.name} className="h-60 w-full object-cover object-top" data-testid={`college-photo-${p.id}`} />
                    )}
                    <div className="p-6">
                      <h3 className="font-condensed text-2xl font-bold uppercase tracking-tight text-slate-900">{p.name}</h3>
                      <p className="text-sm font-bold text-[#D97706] uppercase tracking-wide mt-1">{p.college}</p>
                      {p.team && <p className="text-sm text-slate-600 mt-0.5">{p.team}</p>}
                      <div className="mt-3 flex items-center gap-2 flex-wrap">
                        {p.position && (
                          <span className="bg-[#0F4C2A]/10 text-[#0F4C2A] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-sm">{p.position}</span>
                        )}
                        {p.grad_year && (
                          <span className="bg-slate-100 text-slate-600 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-sm">NHS Class of {p.grad_year}</span>
                        )}
                      </div>
                      {p.bio && <p className="mt-4 text-sm text-slate-600 leading-relaxed">{p.bio}</p>}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
